/**
 * The menu path that owns `pathname`: '/' only on an exact match, anything else
 * by the LONGEST prefix — so /stock/quotes belongs to Quote requests, not Stock,
 * while /stock/123 still belongs to Stock.
 */
export function activePath(pathname: string, paths: string[]): string | null {
  let best: string | null = null;
  for (const p of paths) {
    const hit = p === '/' ? pathname === '/' : pathname === p || pathname.startsWith(`${p}/`);
    if (hit && (best === null || p.length > best.length)) best = p;
  }
  return best;
}
